import Lesson from '../../../api/Lesson';
import * as types from './mutation-types';

export const show = async ({ commit }, {id}) => {
    const json = await new Lesson().show(id);

    commit(types.LESSON, json.data);
};

export const unlock = async ({ commit }, params) => {
    const json = await new Lesson().unlock(params);

    return json;
};

export default {
    show,
    unlock,
};



// WEBPACK FOOTER //
// ./src/store/modules/lesson/actions.js